(ns app.front.ui.components
  (:require [app.front.ui.util :as uiu]))

(def form-field
  (uiu/wrap-in :div.inline-block.mt-4))

(def form-field-wide
  (uiu/wrap-in :div.w-full.mt-5))
